<template>
      <!-- Begin page -->
      <div id="wrapper">
            
            <!-- Top Bar Start -->
            <topbar></topbar>
            <!-- Top Bar End -->
            
            
            <!-- ========== Left Sidebar Start ========== -->
            
            <!-- Left Sidebar End -->
            <left></left>
            <div class="content-page">
                  <!-- Start content -->
                  <div class="content">
                        <div class="container-fluid">
                        
                              <div class="row">
                                    <div class="col-12">
                                          <div class="page-title-box">
                                                <h4 class="page-title float-left">认证专区</h4>
                                          
                                                <ol class="breadcrumb float-right">
                                                      <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                      <li class="breadcrumb-item"><a href="#">认证专区</a></li>
                                                      <li class="breadcrumb-item active">首次认证</li>
                                                </ol>
                                          
                                                <div class="clearfix"></div>
                                          </div>
                                    </div>
                              </div>
                              <!-- end row -->
                        
                        
                              <div class="row">
                                    <div class="col-12">
                                          <div class="card-box">
                                                <h4 class="m-t-0 header-title" style="border-bottom: 1px solid #868686;padding-bottom: 10px;"><b style="font-size: 16px;margin-bottom: 10px;">证书邮寄地址信息确认</b></h4>
                                                <p class="text-muted m-b-30 font-14" style="color: #000000!important;line-height: 30px;margin-bottom: 10px;font-size:15px !important;">确认地址<br/>
                                                      <code>将按照该地址寄送证书，请准确填写</code>
                                                </p>
                                                <div class="row">
                                                      <div class="col-12">
                                                            <div class="p-20" style="max-width: 450px;">

      
                                                                  <div class="" >
                                                                      
                                                                        <select class="form-control" v-model="province" v-on:change="areas_selectcity()" style="height: 40px;max-width: 200px;float:left;margin-right: 10px;">
                                                                              <option v-for="item in slist" v-bind:value="item.area_name">{{item.area_name}}</option>
                                                                        </select>
                                                                  </div>
                                                                  <div class="">
                                                                       
                                                                        <select class="form-control" v-model="city" style="height: 40px;max-width: 200px;float:left;margin-right: 10px;">
                                                                              <option v-for="item in sslist" v-bind:value="item.area_name">{{item.area_name}}</option>
                                                                        </select>
                                                                  </div>
                                                                  <div class="">
                                                                        
                                                                        <input type="text" name="country"
                                                                               v-model="address"
                                                                               class="form-control"
                                                                               placeholder="详细地址"
                                                                               style="max-width: 410px;float:left;margin-top: 10px;"
                                                                        >
                                                                  </div>
                                                                  
                                                            </div>
                                                      </div>
                                          
                                                </div>
                                               <!-- <p class="text-muted m-b-30 font-14" style="color: #000000!important;line-height: 30px;margin-top: 30px;margin-bottom: 10px;font-size:15px !important;">发票信息<br/>
                                                      <code>本年度费用，请在本年度申请开具发票</code>
                                                </p>-->
                                                <div class="row">
                                                      <div class="col-12">
                                                            <div class="p-20">
                                                                <!--
                                                                  <div class="form-group row">
                                                                        <label class="col-2 col-form-label" style="max-width: 500px;">发票内容 : 认证费</label>
                                                                  </div>
                                                                  <div class="form-group row">
                                                                        <label class="col-2 col-form-label" style="max-width: 500px;">发票金额 : 280元</label>
                                                                       
                                                                  </div>
                                                                  <div class="form-group row">
                                                                        <label class="col-2 col-form-label" style="max-width: 100px;">发票类型</label>
                                                                        <div class="col-10" style="padding-top: calc(.375rem + 1px);padding-left:0px;">
                                                                              <input type="radio"  v-model="p_type" value="增值税普通发票"> 增值税普通发票
                                                                              <input type="radio"  v-model="p_type" value="增值税专用发票"> 增值税专用发票
                                                                        </div>
                                                                  </div>
                                                                  <div class="form-group row">
                                                                        <label class="col-2 col-form-label" style="max-width: 100px;">抬头类型</label>
                                                                        <div class="col-10" style="padding-top: calc(.375rem + 1px);padding-left:0px;">
                                                                              <input type="radio" name="country" v-model="t_type" value="企业单位"> 企业单位
                                                                              <input type="radio" name="country" v-model="t_type" value="个人"> 个人
                                                                        </div>
                                                                  </div>
                                                                  <div class="form-group row">
                                                                        <label class="col-2 col-form-label" style="max-width: 100px;">发票抬头</label>
                                                                        <div class="col-10" style="padding-top: calc(.375rem + 1px);padding-left:0px;">
                                                                              <input type="text" name="country"
                                                                                     v-model="title"
                                                                                     class="form-control" style="max-width: 500px;">
                                                                        </div>
                                                                  </div>
                                                                  <div class="form-group row">
                                                                        <label class="col-2 col-form-label" style="max-width: 100px;">税号</label>
                                                                        <div class="col-10" style="padding-top: calc(.375rem + 1px);padding-left:0px;">
                                                                              <input type="text" name="country"
                                                                                     v-model="suihao"
                                                                                     class="form-control" style="max-width: 500px;">
                                                                        </div>
                                                                  </div>
                                                                  <div class="form-group row">
                                                                        <label class="col-2 col-form-label" style="max-width: 100px;">开户行</label>
                                                                        <div class="col-10" style="padding-top: calc(.375rem + 1px);padding-left:0px;">
                                                                              <input type="text" name="country"
                                                                                     v-model="kaihuhang"
                                                                                     class="form-control" style="max-width: 500px;">
                                                                        </div>
                                                                  </div>
                                                                  <div class="form-group row">
                                                                        <label class="col-2 col-form-label" style="max-width: 100px;">账号</label>
                                                                        <div class="col-10" style="padding-top: calc(.375rem + 1px);padding-left:0px;">
                                                                              <input type="text" name="country"
                                                                                     v-model="zhanghao"
                                                                                     class="form-control" style="max-width: 500px;">
                                                                        </div>
                                                                  </div>
                                                                  <div class="form-group row" v-if="this.p_type=='增值税专用发票'">
                                                                        <label class="col-2 col-form-label" style="max-width: 100px;">地址</label>
                                                                        <div class="col-10" style="padding-top: calc(.375rem + 1px);padding-left:0px;">
                                                                              <input type="text" name="country"
                                                                                     v-model="fp_address"
                                                                                     class="form-control" style="max-width: 500px;">
                                                                        </div>
                                                                  </div>
                                                                  <div class="form-group row"  v-if="this.p_type=='增值税专用发票'">
                                                                        <label class="col-2 col-form-label" style="max-width: 100px;">电话</label>
                                                                        <div class="col-10" style="padding-top: calc(.375rem + 1px);padding-left:0px;">
                                                                              <input type="text" name="country"
                                                                                     v-model="fp_tel"
                                                                                     class="form-control" style="max-width: 500px;">
                                                                        </div>
                                                                  </div>

                                                                -->
                        
                                                                  <!--over-->
      
      
      
                                                                  <div style="width: 100%;float:left;padding:20px;text-align:center;">
      
                                                                  <button type="submit" style="margin: 0 auto;"
                                                                          class="btn btn-gradient btn-rounded waves-light waves-effect w-md"
                                                                          v-on:click="edit">提交
                                                                  </button>
                                                                  </div>
                  
                  
                                                            </div>
                                                      </div>
      
                                                </div>
                                                <!-- end row -->
                                    
                                          </div> <!-- end card-box -->
                                    </div><!-- end col -->
                              </div>
                              <!-- end row -->
                          
                  
                        </div> <!-- container -->
            
                  </div> <!-- content -->
            
                <!--footer-->
      
            </div>


      </div>

</template>

<script>
      import topbar from './topbar';
      import left from './left';
      export default {
            name: 'signup',
            components:{topbar,left},
            data() {
                  return {
                        slist:this.slist,
                        sslist:this.sslist,

                        province:this.province,
                        city:this.city,
                        address:this.address,
                        p_type:this.p_type,
                        t_type:this.t_type,
                        title:this.title,
                        suihao:this.suihao,
                        kaihuhang:this.kaihuhang,
                        zhanghao:this.zhanghao,
                        fp_address:this.fp_address,
                        fp_tel:this.fp_tel,

                        out_trade_no:this.$route.query.out_trade_no,
                        
                  }
            },
            mounted(){
                  this.s();
                  this.ss();
                  console.log(this.out_trade_no);
                  
            },
            methods: {
                  edit: function () {
                        //console.log(this.identity);
                        let data = {
                              province:this.province,
                              city:this.city,
                              address:this.address,
                              p_type:this.p_type,
                              t_type:this.t_type,
                              title:this.title,
                              suihao:this.suihao,
                              kaihuhang:this.kaihuhang,
                              zhanghao:this.zhanghao,
                              fp_address:this.fp_address,
                              fp_tel:this.fp_tel,

                              out_trade_no:this.out_trade_no,
                        }
                        this.$axios({
                              method: 'post',
                              url: '/api/member2/Authentication_fapiao',
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              if(response.data.code==0){
                                    /*
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'success',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                                    
                                     */
                                    window.location.href="/member2/#/Authentication";
                              }else{
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'error',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              }


                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  next:function () {
                        //this.$router.push({path:'/Authentication_step2'});
                        window.location.href="/member2/#/Authentication";
                  },
                  s: function () {
                        this.$axios({
                              method: 'get',
                              url: '/api/areas_s',
                              headers:{
                                    apitoken:localStorage.getItem('apitoken')
                              }
                        }).then(function OnSuccess(response) {
                              this.slist=response.data;
                        }.bind(this)).catch(function OnError(response) {
                              console.log(response)
                        })
                  },
                  ss: function () {
                        //console.log("three:"+this.province)
                        let data={
                              city:this.city,
                        }
                        this.$axios({
                              method: 'post',
                              url: '/api/areas_ss',
                              data:data,
                              headers:{
                                    apitoken:localStorage.getItem('apitoken')
                              }
                        }).then(function OnSuccess(response) {
                              this.sslist=response.data;
                        }.bind(this)).catch(function OnError(response) {
                              console.log(response)
                        })
                  },
                  areas_selectcity: function () {
                        //console.log("three:"+this.province)
                        let data={
                              province:this.province,
                        }
                        this.$axios({
                              method: 'post',
                              url: '/api/areas_selectcity',
                              data:data,
                              headers:{
                                    apitoken:localStorage.getItem('apitoken')
                              }
                        }).then(function OnSuccess(response) {
                              this.sslist=response.data;
                              this.city='';
                        }.bind(this)).catch(function OnError(response) {
                              console.log(response)
                        })
                  },
                  //method over

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx{width:100%;}
      .zx li{width:100%;float: left}

  
     
</style>



// WEBPACK FOOTER //
// src/components/Authentication_fapiao.vue